<div class="step-title">
  <h2>Login</h2>
</div>
<span class="step-desc"
  >In order to connect to your external MaM provider, provide the following
  details.</span
>

<div class="login-data-container">
  <div class="login-data-container-inner">
    <h3 class="login-data-container-title">Connect to an existing account</h3>
    <span class="login-data-container-desc">to log into {{ serviceName }}</span>
    <div class="login-data-container-form">
      <ng-container
        *ngFor="let data of loginData | keyvalue: KeepOriginalOrder"
      >
        <div *ngIf="data.key === 'authType'" class="auth-type-field">
          <label class="auth-type-label">Authentication Type</label>
          <mat-radio-group
            [value]="data.value || 'perCall'"
            (change)="updateLoginDirect(data.key, $event.value)"
          >
            <mat-radio-button value="perCall">Per Call</mat-radio-button>
            <mat-radio-button value="jwt">JWT</mat-radio-button>
          </mat-radio-group>
        </div>

        <mat-form-field *ngIf="data.key !== 'authType'" appearance="outline">
          <mat-label> {{ data.key }} </mat-label>
          <input
            matInput
            [attr.type]="data.key === 'password' ? 'password' : 'text'"
            [attr.placeholder]="data.key"
            [attr.value]="data.value"
            (change)="updateLogin($event, data.key)"
            required
          />
        </mat-form-field>
      </ng-container>

      <button class="login-data-container-button" (click)="testConnection()">
        <span>{{ TestConnectionButtonText() }}</span>
      </button>
    </div>
  </div>
</div>
<ng-container *ngIf="isDalet && loginOk">
  <div class="step-title">
    <h2>Drop Bucket</h2>
  </div>
  <div class="login-data-container">
    <div class="login-data-container-inner">
      <h3 class="login-data-container-title">Incoming file drop bucket</h3>
      <span class="login-data-container-desc"
        >Files placed in this bucket will be automatically matched and
        imported.</span
      >
      <div class="login-data-container-form">
        <mat-form-field appearance="outline">
          <mat-label>Bucket Name</mat-label>
          <input
            matInput
            placeholder="my-bucket"
            [attr.value]="dropBucket?.['bucketName']"
            (change)="updateDropBucketField('bucketName', $event.target.value)"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Region</mat-label>
          <input
            matInput
            placeholder="us-ashburn-1"
            [attr.value]="dropBucket?.['region']"
            (change)="updateDropBucketField('region', $event.target.value)"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Prefix (optional)</mat-label>
          <input
            matInput
            placeholder="incoming/"
            [attr.value]="dropBucket?.['prefix']"
            (change)="updateDropBucketField('prefix', $event.target.value)"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Access Key</mat-label>
          <input
            matInput
            [attr.value]="dropBucket?.['accessKey']"
            (change)="updateDropBucketField('accessKey', $event.target.value)"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Secret Key</mat-label>
          <input
            matInput
            type="password"
            [attr.value]="dropBucket?.['secretKey']"
            (change)="updateDropBucketField('secretKey', $event.target.value)"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-container>

<div class="step-title">
  <h2>Languages and Subtitles</h2>
</div>
<div class="lns-container">
  <div>
    <h3>languages</h3>
    <multi-checkbox-selection
      class="checkboxes"
      [data]="$any(languages)"
      [selected]="$any(selectedLanguages)"
      (valueChange)="languagesChange($event)"
    >
    </multi-checkbox-selection>
  </div>
  <div>
    <h3>subtitles</h3>
    <multi-checkbox-selection
      class="checkboxes"
      [data]="$any(languages)"
      [selected]="$any(selectedSubtitles)"
      (valueChange)="subtitlesChange($event)"
    >
    </multi-checkbox-selection>
  </div>
</div>
<div class="step-title">
  <h2>MAM Settings</h2>
</div>
<div class="mam-settings-container">
  <div>
    <label>MAM Name: </label>
    <mat-form-field appearance="outline">
      <mat-label> Name </mat-label>
      <input
        matInput
        placeholder="My {{ serviceName }}"
        [attr.value]="gatewayName"
        (change)="updateGeneralFromInput('name', $event)"
      />
    </mat-form-field>
  </div>
  <div>
    <mat-checkbox
      [checked]="autoPull"
      [color]="'primary'"
      (change)="updateGeneral('autoPull', $event.checked)"
    ></mat-checkbox>
    <span class="step-desc"> Automaticlly pull missing files </span>
  </div>
  <div>
    <mat-checkbox
      [checked]="isActive"
      [color]="'primary'"
      (change)="updateState($event.checked)"
    ></mat-checkbox>
    <span class="step-desc">
      Operational Status:
      <strong>{{ isActive ? "Active" : "Deactivated" }}</strong></span
    >
  </div>
</div>
